import React, { useEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import "../../styles/Impact.scss";

gsap.registerPlugin(ScrollTrigger);

const TEXT = "Impact";

const Impact: React.FC = () => {
  const sectionRef = useRef<HTMLElement | null>(null);
  const lettersRef = useRef<HTMLSpanElement[]>([]);

  useEffect(() => {
    if (!sectionRef.current) return;

    const letters = lettersRef.current;

    gsap.set(letters, {
      opacity: 0,
      rotateX: 160,
      y: 160,
      transformOrigin: "bottom center",
    });

    ScrollTrigger.create({
      trigger: sectionRef.current,
      start: "top 100%",   
      end: "center center",
      scrub: true,        
      onUpdate: (self) => {
        const progress = self.progress;
        const direction = self.direction;

        gsap.to(letters, {
          opacity: progress,
          rotateX: direction === 1 ? 120 * (1 - progress) : -120 * (1 - progress),
          y: (1 - progress) * (direction === 1 ? 120 : -120),
          stagger: {
            each: 0.08,
            from: direction === 1 ? "start" : "end",
          },
          ease: "none",
          overwrite: true,
        });
      },
    });

    return () => {
      ScrollTrigger.getAll().forEach(t => t.kill());
    };
  }, []);

  return (
    <section className="impact-section" ref={sectionRef}>
      <div className="impact-content">
        <h1 className="impact-title">
          {TEXT.split("").map((char, i) => (
            <span
              key={i}
              className="impact-letter"
              ref={(el) => {
                if (el) lettersRef.current[i] = el;
              }}
            >
              {char}
            </span>
          ))}
        </h1>
      </div>
    </section>
  );
};

export default Impact;
